import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { useFilters } from './FilterContext';

function ListingSkeleton() {
    const { isSkeletonLoading } = useFilters();

    return (
        <>
            {isSkeletonLoading && (
                <>
                        <div className="leftNav" id="left_panel">
                            <Skeleton count={1} height={'100vh'} width={'100%'} />
                        </div>
                        <div className="right-section">
                            <div className="header-section">
                                <div>
                                    <Skeleton count={1} height={45} width={'40%'} style={{ marginBottom: '20px' }} />
                                    <Skeleton count={1} height={60} width={'100%'} />
                                </div>
                                <div className="sort-options">
                                    <Skeleton count={1} height={45} width={'40%'} />
                                </div>
                            </div>
                            <div className="product-grid">
                                <div className="card"><Skeleton count={1} height={382} width={'100%'} /></div>
                                <div className="card"><Skeleton count={1} height={382} width={'100%'} /></div>
                                <div className="card"><Skeleton count={1} height={382} width={'100%'} /></div>
                                <div className="card fourth-card"><Skeleton count={1} height={382} width={'100%'} /></div>
                            </div>
                            <div></div>
                            </div>
                    {/* <div className="leftNav" id="right_panel">
                        <Skeleton count={1} height={565} width={'100%'} />
                    </div>
                    <div className='cat_description row 1'>
                        <Skeleton count={1} height={100} width={'100%'} />
                    </div>
                    <div className='custom_filter_navitation right-section'>
                        <div className='product_display_list'>
                            <div className='top_panel_handler'>
                                <div className='category-name-sort'>
                                    <Skeleton count={1} height={45} width={'20%'} />
                                    <Skeleton count={1} height={45} width={'20%'} />
                                </div>
                                <Skeleton count={1} height={60} width={'100%'} />
                            </div>
                            <ul className='productGrid basket_product_list'>
                                <li className='product'>
                                    <Skeleton count={1} height={382} width={'100%'} />
                                </li>
                                <li className='product'>
                                    <Skeleton count={1} height={382} width={'100%'} />
                                </li>
                                <li className='product'>
                                    <Skeleton count={1} height={382} width={'100%'} />
                                </li>
                                <li className='product'>
                                    <Skeleton count={1} height={382} width={'100%'} />
                                </li>
                            </ul>
                        </div>
                    </div> */}
                </>
            )}

        </>
    )
}

export default ListingSkeleton;
